import { render, staticRenderFns } from "./newsDetial.vue?vue&type=template&id=0e5b4813&scoped=true&"
import script from "./newsDetial.vue?vue&type=script&lang=js&"
export * from "./newsDetial.vue?vue&type=script&lang=js&"
import style0 from "./newsDetial.vue?vue&type=style&index=0&id=0e5b4813&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b4813",
  null
  
)

export default component.exports